import React from "react";
import "./SeqIdTable.css";

function SeqIdTable({ seqidTable }) {
  if (!seqidTable || seqidTable.length === 0) {
    return <p>No sequence Table data available.</p>;
  }

  return (
    <table className="seq-table">
      <thead>
        <tr>
          <th>SEQ ID NO</th>
          <th>Description</th>
          <th>Sequence Type</th>
          <th>Claims</th>
        </tr>
      </thead>
      <tbody>
        {seqidTable.map((row, index) => (
          <tr key={row.id ?? index}>
            <td>{row.seq_id_no}</td>
            <td>{row.description}</td>
            <td>{row.sequence_type}</td>
            <td>{row.claims}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default SeqIdTable;
